<template>
  <aha-modal
    :title="title_CannotSaveChanges"
    v-if="hasErrorOnUpdatingUser"
    @hide="$emit('hide')"
    action-position="justify-center"
  >
    <div>
      <span>{{ $i18nPresenter.t('Please try again.') }}</span>
      <ui-messages type="problemOccurs" />
    </div>
    <template #action>
      <aha-button @click="$emit('click')">
        {{ $i18nPresenter.t('OK') }}
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
import Messages from '@/components/UI/Messages.vue'

export default {
  components: {
    UiMessages: Messages,
  },
  props: {
    hasErrorOnUpdatingUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title_CannotSaveChanges: this.$i18nPresenter.t('Cannot save the changes'),
    }
  },
}
</script>
